import styled from "styled-components";
import { DatePicker as AntdDatePicker } from "antd";

export const DatePicker = styled(AntdDatePicker)`
  display: flex;
`;
